export enum BusinessCustomerTypesEnum {
  ltd = 'ltd',
  plc = 'plc',
  soleTrader = 'soleTrader',
  partnership = 'partnership',
  other = 'other',
  unlimited = 'unlimited',
}

export interface BusinessCustomerTypeFormModel {
  selectedBusinessCustomerType?: BusinessCustomerTypesEnum;
}
